import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'timeFromNow',
  standalone: true,
})
export class TimeFromNowPipe implements PipeTransform {
  transform(value: string): string {
    const now = moment();
    const past = moment(value);
    return past.fromNow();
  }
}
